/* global axios */
import ApiClient from '../ApiClient';

class CaptainAssistantMediaAPI extends ApiClient {
  constructor() {
    super('captain_assistants', { accountScoped: true, saas: true });
  }

  get(assistantId) {
    return axios.get(`${this.url}/${assistantId}/media`);
  }

  create(assistantId, file) {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${this.url}/${assistantId}/media`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  delete(assistantId, mediaId) {
    return axios.delete(`${this.url}/${assistantId}/media/${mediaId}`);
  }
}

export default new CaptainAssistantMediaAPI();
